import { render, staticRenderFns } from "./NewScan.vue?vue&type=template&id=1a8c9ed6"
import script from "./NewScan.vue?vue&type=script&lang=js"
export * from "./NewScan.vue?vue&type=script&lang=js"
import style0 from "./NewScan.vue?vue&type=style&index=0&id=1a8c9ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports